import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { PageTransitionsHandlerSymbol, ThunderboltRootComponentRendererSym } from '../symbols'
import { PageTransitionsHandler } from './dsPageTransitionsHandler'
import { AppDidMountPromiseSymbol, BatchingStrategySymbol, LifeCycle, RendererSymbol } from '@wix/thunderbolt-symbols'
import { appDidMountPromise, AppRootRenderer, ReactClientRenderer } from '../clientRenderer/reactClientRenderer'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { bindCommonSymbols } from '../bindCommonSymbols'
import { ClientBatchingStrategy } from '../components/clientBatchingStrategy'
import { ComponentCssRootRenderer } from '../clientRenderer/ComponentCssRootRenderer'

export const editor: ContainerModuleLoader = (bind) => {
	bindCommonSymbols(bind)
	bind(BatchingStrategySymbol, LifeCycle.AppDidMountHandler).to(ClientBatchingStrategy)
	bind(AppDidMountPromiseSymbol).toConstantValue(appDidMountPromise)
	bind(ThunderboltRootComponentRendererSym).to(ComponentCssRootRenderer)
	bind(ThunderboltRootComponentRendererSym).to(AppRootRenderer)
	bind(RendererSymbol).to(ReactClientRenderer)
	bind(LifeCycle.AppWillLoadPageHandler, PageTransitionsHandlerSymbol, ModelUpdatesHandlersImplementor).to(
		PageTransitionsHandler
	)
}
